/** Localized labels in the pinned upstream category order. */
export const MOODIST_LABELS: Record<string, string[]> = {
  nature: '河流 海浪 篝火 风声 狂风 林间风 瀑布 雪地脚步 落叶脚步 碎石脚步 水滴 丛林'.split(' '),
  rain: '小雨 大雨 雷声 窗上雨 车顶雨 雨伞雨 帐篷雨 叶上雨'.split(' '),
  animals: '鸟鸣 海鸥 蟋蟀 狼嚎 猫头鹰 蛙鸣 狗叫 马蹄 猫咪呼噜 乌鸦 鲸鸣 蜂巢 啄木鸟 鸡鸣 牛鸣 羊鸣'.split(' '),
  urban: '高速公路 道路 救护车警笛 繁华街道 人群 车流 烟花'.split(' '),
  places: '咖啡馆 机场 教堂 寺庙 工地 水下 酒吧 夜间村庄 地铁站 办公室 超市 旋转木马 实验室 洗衣房 餐厅 图书馆'.split(' '),
  transport: '火车 火车车厢 飞机 潜艇 帆船 划船'.split(' '),
  things: '键盘 打字机 纸张 时钟 风铃 颂钵 吊扇 烘干机 幻灯机 沸水 气泡 收音机调频 摩斯电码 洗衣机 黑胶唱片 雨刷'.split(' '),
  noise: '白噪音 粉红噪音 棕噪音'.split(' '),
}
